import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboarding } from './OnboardingContext';

export function ConfirmationStep({ stepId }) {
  const { profileDraft, authUser, nextStep, markStepComplete } = useOnboarding();
  const navigate = useNavigate();

  const firstName = profileDraft.full_name?.split(' ')[0] || authUser?.user_metadata?.full_name?.split(' ')[0] || 'Athlete';

  const handleContinue = () => {
    markStepComplete(stepId);
    nextStep();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl bg-white rounded-3xl shadow-lg border border-blue-100 p-10 space-y-6">
        <div className="text-center space-y-2">
          <h2 className="text-3xl font-semibold text-gray-900">You’re all set, {firstName}!</h2>
          <p className="text-sm text-gray-600">Here’s a preview of what’s waiting on your dashboard.</p>
        </div>

        <div className="bg-white border border-gray-200 rounded-3xl shadow-sm p-6 space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs uppercase tracking-wide text-gray-500">Next workout</p>
              <h3 className="text-xl font-semibold text-gray-900 mt-1">Strength Builder</h3>
              <p className="text-sm text-gray-600 mt-1">3 supersets • 45 minutes • Push focus</p>
            </div>
            <span className="text-3xl">💪</span>
          </div>
          <div className="grid grid-cols-2 gap-3 text-sm text-gray-600">
            <div className="bg-blue-50 rounded-2xl px-4 py-3">
              <p className="font-semibold text-blue-900">Weekly streak</p>
              <p className="text-blue-700 mt-1">2/4 sessions</p>
            </div>
            <div className="bg-green-50 rounded-2xl px-4 py-3">
              <p className="font-semibold text-green-900">AI insight</p>
              <p className="text-green-700 mt-1">“Lifted 12% heavier than last week”</p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <button
            type="button"
            data-testid="onboarding-start-training"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl transition-colors"
            onClick={() => navigate('/dashboard')}
          >
            Start Training
          </button>
          <button
            type="button"
            data-testid="onboarding-continue-final"
            className="w-full bg-white border border-gray-300 hover:border-gray-400 text-gray-800 font-semibold px-6 py-3 rounded-xl transition-colors"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
